<div class="cmps-widget-external-content">
    <cmps-wait-status
        [absolute]="true"
        *ngIf="!ready"
    ></cmps-wait-status>
    <iframe
        class="cmps-iframe"
        title
        cmps-iframe
        [newSrc]="url"
        [hasComm]="true"
        (onload)="ready = true"
        (unload)="ready = false"
        #iframe="cmpsIframe"
    ></iframe>
</div>
